// extracted by mini-css-extract-plugin
export default {"faction":"mtBgR2FSJIXEpkSN7sO8","factionColor":"HpRLvOUMHMCvg3lQqeRq"};